'use strict';

var _ = require('lodash');
var StepSponsorshipFlightController = function StepSponsorshipFlightController($scope, validationService) {
  $scope.isSummaryVisible = false;
  $scope.sponsorDataInitialized = false;
  $scope.stepTitle = 'Sponsor Flight Forecast';
  $scope.nextStepTitle = 'Review Rules';
  function unwindFlightSponsors() {
    var newManagedEntities = [];
    _.forEach($scope.scheduleChange.managedEntities, function (entity) {
      var flightSponsorDefined = entity.flightSponsor !== undefined;
      var isArray = _.isArray(entity.flightSponsor);
      if (isArray) {
        _.forEach(entity.flightSponsor, function (sponsor) {
          var clonedEntity = _.cloneDeep(entity);
          clonedEntity.flightSponsor = sponsor;
          newManagedEntities.push(clonedEntity);
        });
      }
      if (flightSponsorDefined && !isArray) {
        newManagedEntities.push(entity);
      } else if (!flightSponsorDefined || entity.flightSponsor.length === 0) {
        newManagedEntities.push(entity);
        entity.flightSponsor = undefined;
      }
    });
    $scope.scheduleChange.managedEntities = newManagedEntities;
  }
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle) {
      unwindFlightSponsors();
      $scope.isSummaryVisible = false;
      $scope.sponsorDataInitialized = true;
    }
  };

  /**
   * If the leg wizard, flight sponsors are optional.
   * If the flight wizard, all flight sponsors are required.
   * @returns {boolean}
   */
  $scope.validate = function () {
    if ($scope.isLegsWizard()) {
      $scope.isSummaryVisible = false;
      return true;
    }
    $scope.isSummaryVisible = _.some($scope.scheduleChange.managedEntities, function (entity) {
      return _.isEmpty(entity.flightSponsor);
    });
    return !$scope.isSummaryVisible;
  };
  $scope.resetSummaryMessage = function () {
    $scope.isSummaryVisible = false;
  };
  validationService.registerValidator('StepSponsorshipFlight', $scope.validate);
};
StepSponsorshipFlightController.$inject = ['$scope', 'ValidationService'];
module.exports = StepSponsorshipFlightController;